import PropTypes from 'prop-types';
import React from 'react';

import { Consumer as PageConsumer } from '../../../../contexts/PageContext';
import Button from '../../../Input/Button/Button';

import InputField from '../../../Input/InputField/InputField';
import SearchSelect from '../../../Input/Select/SearchSelect';
import TextArea from '../../../Input/TextArea/TextArea';

import './CommentFormToolTip.scss';

export class CommentFormToolTip extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
        };
    }

    static propTypes = {
        /**
         * whether to show this component
         */
        showForm: PropTypes.bool.isRequired,
        /**
         * type of tip field
         */
        tipInputType: PropTypes.string,
        /**
         * whether to show the tip input box
         */
        showTipField: PropTypes.bool,
        /**
         * Title of the form
         */
        title: PropTypes.string.isRequired,
        /**
         * user entered tip
         */
        tip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /**
         * user entered comment
         */
        comment: PropTypes.string,
        /**
         * on tip input change function
         */
        onTipChange: PropTypes.func,
        /**
         * on comment input change function
         */
        onCommentChange: PropTypes.func.isRequired,
        /**
         * function to close form
         */
        closeForm: PropTypes.func,
        /**
         * function to clear form
         */
        clearForm: PropTypes.func,
        /**
         * function to trigger modal from page context
         */
        modalTrigger: PropTypes.func,
    };

    static defaultProps = {
        showTipField: true,
        onTipChange: () => {},
        tip: '',
        comment: '',
        tipInputType: 'inputBox',
    };

    onErrorPopUpClose = () => {
        this.setState({ showError: false });
    };

    renderTipField = (tipInputType) => {
        if (tipInputType === 'dropdown') {
            let options = [
                {
                    name: 'Available',
                    value: 1,
                },
                {
                    name: 'Not Available',
                    value: '2',
                },
            ];

            return (
                <div className="gray-border">
                    <SearchSelect
                        onChange={this.props.onTipChange}
                        value={this.props.tip}
                        options={options}
                        name="tip"
                        className="pt-2"
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <InputField
                        name="tip"
                        type="text"
                        onChange={this.props.onTipChange}
                        placeholder={'Enter a number between 0-52'}
                        value={this.props.tip}
                    />
                </div>
            );
        }
    };

    renderForm = () => {
        return (
            <div className="text-left">
                {this.props.showTipField ? (
                    <div className="mb-2 tip-input">
                        <p>Enter a Tip</p>
                        {this.renderTipField(this.props.tipInputType)}
                    </div>
                ) : null}

                <div className="mb-2 comment-input">
                    <p>Comment:</p>
                    <TextArea
                        rows={5}
                        cols={37}
                        name="comment"
                        onChange={this.props.onCommentChange}
                        value={this.props.comment}
                    />
                </div>

                <div className="button-div submit">
                    <Button
                        type="solid"
                        value="Submit"
                        onClick={this.onSubmit}
                    />
                </div>
            </div>
        );
    };

    validateTip = () => {
        if (!this.props.tip && this.props.comment) {
            return true;
        }

        let tip = parseInt(this.props.tip);

        if (isNaN(tip) || tip < 0 || tip > 52) {
            return false;
        } else {
            return true;
        }
    };

    validateFields = () => {
        return this.props.tip || this.props.comment;
    };

    onSubmit = () => {
        let valid = true;
        let isAtLeastOneFieldFilled = true;
        let isTipValid = true;

        if (this.props.showTipField && this.props.type !== 'dropdown') {
            isAtLeastOneFieldFilled = this.validateFields();
            isTipValid = this.validateTip();

            valid = isAtLeastOneFieldFilled && isTipValid;
        }

        if (valid) {
            this.props.onSubmit();
        } else {
            const modalData = {
                buttonMetas: [
                    {
                        buttonText: 'Continue',
                        buttonType: 'purple-medium-white',
                    },
                ],
                imageSrc: '/v1/icons/fgb-bubble-logo.png',
                heading: 'Oops! Something went wrong!',
            };

            if (!isAtLeastOneFieldFilled) {
                modalData.subheading = 'Please fill in at least one field.';
            } else if (!isTipValid) {
                modalData.subheading = 'Please enter a number between 0-52.';
            }

            this.props.modalTrigger('ConfirmationModal', modalData);
        }
    };

    render() {
        if (!this.props.showForm) {
            return null;
        }

        return (
            <div className="component-Employer-Benefits-CommentFormToolTip">
                <div className="close" onClick={this.props.closeForm} />

                <div className="tooltip-header">{this.props.title}</div>

                <div className="tooltip-body">{this.renderForm()}</div>
            </div>
        );
    }
}

export default (props) => (
    <PageConsumer>
        {({ modalTrigger }) => (
            <CommentFormToolTip {...props} modalTrigger={modalTrigger} />
        )}
    </PageConsumer>
);
